<template>
    <span>
        <v-btn icon color="red" @click="deleteConfirmation()">
            <v-icon>fas fa-times-circle</v-icon>
        </v-btn>
        <v-dialog v-model="showDeleteConfirmation" width="40%">
            <v-card>
                <v-card-title>
                    <h2 class="red--text">{{title}}</h2>
                </v-card-title>
                <v-card-text>
                    <p>{{text}}</p>
                    <v-progress-linear indeterminate v-if="delete_loading"></v-progress-linear>
                    <div class="text-center">
                        <v-btn color="red" @click="deleteIt" class="mr-5">Yes!</v-btn>
                        <v-btn @click="showDeleteConfirmation = false">Cancel</v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </span>
</template>
<script>
export default {
    name: "QDeleteConfirmation",
    props: ['text', 'title', 'item'], // data passed to component from parent
    data: function() { // data internal to component (not available outside)
        return {
            showDeleteConfirmation: false,
            delete_loading: false
        }
    },
    computed: {

    },
    methods: {
        deleteConfirmation: function() {
            this.showDeleteConfirmation = true
        },
        deleteIt: function() {
            this.$emit("delete", this.item);
            this.showDeleteConfirmation = false
        }

    },
    watch: {

    },
}
</script>
<style scoped>
</style>